import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebaseの設定
const firebaseConfig = {
  apiKey: "AIzaSyAIGh-x9wzCDf5aFQKho7WMotjmKHu8xEg",
  authDomain: "miyazaki-tsu-quiz.firebaseapp.com",
  projectId: "miyazaki-tsu-quiz",
  storageBucket: "miyazaki-tsu-quiz.firebasestorage.app",
  messagingSenderId: "238898926807",
  appId: "1:238898926807:web:96415ebcca2482cc5c8c92"
};

// Firebaseの初期化
const app = initializeApp(firebaseConfig);

// Firestoreのインスタンスを取得
export const db = getFirestore(app);
